import React from "react";
import TitleHeader from "../../../../components/Common/TitleHeader";
import {
  ColumnContainer,
  ResContainer,
} from "../../../../helpers/StyledComponents";
import BookCard from "../../../../components/Book/BookCard";

const KnowMore = () => {
  return (
    <ColumnContainer>
      <TitleHeader th="หนังสือที่ระลึก" center />
      <ResContainer gap="20">
        <BookCard
          title="หนังสือที่ระลึก 45 ปี"
          desc="1970-2015 - 8/11/2015"
          img="/webImg/SU45.jpg"
          link="https://drive.google.com/file/d/1qSY9ePrdxzCQFEVwKx90KXhvelgjOquh/view?usp=sharing"
          showViewBtn
        />
        <BookCard
          title="หนังสือที่ระลึก 50 ปี"
          desc="15/11/2020"
          img="/webImg/SU50.jpg"
          link="https://drive.google.com/file/d/1hxKj1NaBtXYalUhFpmTITGmGU2nneVSA/view?usp=sharing"
          showViewBtn
        />
      </ResContainer>
    </ColumnContainer>
  );
};

export default KnowMore;
